import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'donationYear';

export interface FormValues {
  donationStartYear: number | null;
  donationEndYear: number | null;
}

export const validation = yup.object().shape({
  donationStartYear: yup
    .number()
    .nullable()
    .required('Please, enter the start year'),

  donationEndYear: yup
    .number()
    .nullable()
    .when('$isRecurring', {
      is: true,
      then: yup
        .number()
        .nullable()
        .required('Please, enter the end year')
        // eslint-disable-next-line func-names
        .test('is-greater', 'End Year must be greater than the Start Year', function(value) {
          const { donationStartYear } = this.parent;

          if (!value || !donationStartYear) {
            return true;
          }

          return value > donationStartYear;
        }),
    }),
});
